import { useState, useEffect } from "react";

const TABLET_QUERY = "(min-width: 768px) and (max-width: 1199px)";

export function useIsTablet(): boolean {
  const [isTablet, setIsTablet] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(TABLET_QUERY).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(TABLET_QUERY);
    const handler = (e: MediaQueryListEvent) => setIsTablet(e.matches);

    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", handler);
      return () => mql.removeEventListener("change", handler);
    } else if (typeof (mql as any).addListener === "function") {
      (mql as any).addListener(handler);
      return () => (mql as any).removeListener(handler);
    }

    return () => {};
  }, []);

  return isTablet;
}
